export default __webpack_public_path__ + "static/media/Contract Stability.2095063a.svg";